import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SurvicateService {
  private initShow = false;
  private _finishedLoadingPortal = false;
  private storage: Storage;

  constructor() {
    this.storage = window.localStorage;
  }

  public get finishedLoadingPortal() {
    return this._finishedLoadingPortal;
  }
  public set finishedLoadingPortal(value) {
    this._finishedLoadingPortal = value;
  }

  public onBack() {
    setTimeout(function () {
      window.history.forward();
    }, 0);
    window.onunload = function () {
      null;
    };
  }

  public onCompleteSignature() {
    setTimeout(() => {
      const lastMonth = new Date();
      lastMonth.setMonth(new Date().getMonth() - 1);
      const lastShowSurvicate = this.storage.getItem(
        'Survicate.onCompleteSignature'
      );

      if (!lastShowSurvicate || new Date(lastShowSurvicate) < lastMonth) {
        this.storage.setItem(
          'Survicate.onCompleteSignature',
          new Date().toString()
        );

        if (!this.isInternal()) {
          window['_sva'].showSurvey(
            SurvicateConstants.CSAT_ASSINATURA,
            SurvicateConstants.options
          );
        } else {
          window['_sva'].showSurvey(
            SurvicateConstants.CSAT_INTERNO_ASSINATURA,
            SurvicateConstants.options
          );
        }

        const completeEvent = function (surveyId) {
          if (
            surveyId === SurvicateConstants.CSAT_ASSINATURA ||
            surveyId === SurvicateConstants.CSAT_INTERNO_ASSINATURA
          ) {
            window['_sva'].showSurvey(
              SurvicateConstants.CES_ASSINATURA,
              SurvicateConstants.options
            );
          } else if (surveyId === SurvicateConstants.CES_ASSINATURA) {
            window['_sva'].showSurvey(
              SurvicateConstants.PMF_ASSINATURA,
              SurvicateConstants.options
            );
          }
        };

        window['_sva'].addEventListener('survey_completed', completeEvent);
        window['_sva'].addEventListener('survey_closed', completeEvent);
      }
    }, 2000);
  }

  public onCreateEnvelope() {
    setTimeout(() => {
      const lastMonth = new Date();
      lastMonth.setMonth(new Date().getMonth() - 1);
      const lastShowSurvicate = this.storage.getItem(
        'Survicate.onCreateEnvelope'
      );

      if (!lastShowSurvicate || new Date(lastShowSurvicate) < lastMonth) {
        this.storage.setItem(
          'Survicate.onCreateEnvelope',
          new Date().toString()
        );

        if (!this.isInternal()) {
          window['_sva'].showSurvey(
            SurvicateConstants.CSAT_ENVELOPE,
            SurvicateConstants.options
          );
        } else {
          window['_sva'].showSurvey(
            SurvicateConstants.CSAT_INTERNO_ENVELOPE,
            SurvicateConstants.options
          );
        }

        const completeEvent = function (surveyId) {
          if (
            surveyId === SurvicateConstants.CSAT_ENVELOPE ||
            surveyId === SurvicateConstants.CSAT_INTERNO_ENVELOPE
          ) {
            window['_sva'].showSurvey(
              SurvicateConstants.CES_ENVELOPE,
              SurvicateConstants.options
            );
          } else if (surveyId === SurvicateConstants.CES_ENVELOPE) {
            window['_sva'].showSurvey(
              SurvicateConstants.PMF_ENVELOPE,
              SurvicateConstants.options
            );
          }
        };

        window['_sva'].addEventListener('survey_completed', completeEvent);
        window['_sva'].addEventListener('survey_closed', completeEvent);
      }
    }, 2000);
  }

  public onInitPortal() {
    setTimeout(() => {
      const lastMonth = new Date();
      lastMonth.setMonth(new Date().getMonth() - 1);
      const lastShowSurvicate = this.storage.getItem('Survicate.onInitPortal');

      this.finishedLoadingPortal = true;

      if (!lastShowSurvicate || new Date(lastShowSurvicate) < lastMonth) {
        this.storage.setItem('Survicate.onInitPortal', new Date().toString());

        if (this.initShow) {
          return;
        }

        if (!this.isInternal()) {
          window['_sva'].showSurvey(
            SurvicateConstants.CSAT_PORTAL,
            SurvicateConstants.options
          );
        } else {
          window['_sva'].showSurvey(
            SurvicateConstants.CSAT_INTERNO_PORTAL,
            SurvicateConstants.options
          );
        }

        const completeEvent = function (surveyId) {
          if (
            surveyId === SurvicateConstants.CSAT_PORTAL ||
            surveyId === SurvicateConstants.CSAT_INTERNO_PORTAL
          ) {
            window['_sva'].showSurvey(
              SurvicateConstants.PMF_PORTAL,
              SurvicateConstants.options
            );
          }
        };

        window['_sva'].addEventListener('survey_completed', completeEvent);
        window['_sva'].addEventListener('survey_closed', completeEvent);

        this.initShow = true;
      }
    }, 2000);
  }

 public setUser(user: SurvicateUser) {  
  setTimeout(() => {    
    if (window['_sva'] ){
      window['_sva'].setVisitorTraits({
        email: user.email,
        first_name: user.email, 
        tenant: location.hostname.split('.')[0],
      });
    } 
  }, 2000);
}

  public isSignFree(): boolean {
    return (
      location.hostname.split('.')[0] === SurvicateConstants.TENANT_SIGNFREE || 
      location.hostname.split('.')[0] === SurvicateConstants.TENANT_LOCAL
    );
  }

  private isInternal(): boolean {
    return (
      location.hostname.split('.')[0] === SurvicateConstants.TENANT_SELBETTI ||
      location.hostname.split('.')[0] === SurvicateConstants.TENANT_LOCAL
    );
  }

  public checkEnvironment(): boolean {
      return location.hostname.split('.')[1] === SurvicateConstants.DEV ||
        location.hostname.split('.')[0] === SurvicateConstants.PRE_RELEASE ||
        location.hostname.split('.')[0] === SurvicateConstants.TENANT_LOCAL;
  }
}

export class SurvicateConstants {
  public static get CSAT_PORTAL(): string {
    return '8bf887ea39165f2b';
  }
  public static get CSAT_INTERNO_PORTAL(): string {
    return '84c879dfda401be1';
  }
  public static get PMF_PORTAL(): string {
    return '1c64b0ac7d1eb124';
  }

  public static get PMF_ASSINATURA(): string {
    return '53b4af7409af98a6';
  }
  public static get CSAT_INTERNO_ASSINATURA(): string {
    return 'e24e8172cc7ddccd';
  }
  public static get CSAT_ASSINATURA(): string {
    return '65a463d0eb326f4c';
  }
  public static get CES_ASSINATURA(): string {
    return 'c65d5ef26536721c';
  }

  public static get PMF_ENVELOPE(): string {
    return '53b4af7409af98a6';
  }
  public static get CES_ENVELOPE(): string {
    return '3fc09236acedb70f';
  }
  public static get CSAT_INTERNO_ENVELOPE(): string {
    return '48120bea347ec10d';
  }
  public static get CSAT_ENVELOPE(): string {
    return '37ed508a0fa1ee5c';
  }

  public static get TENANT_SELBETTI(): string {
    return 'selbetti';
  }
  public static get TENANT_LOCAL(): string {
    return '127';
  }
  public static get TENANT_SIGNFREE(): string {
    return 's-sign';
  }
  public static get DEV(): string {
    return 'dev';
  };
  public static get PRE_RELEASE(): string {
    return 'pre-release';
  };

  public static get options(): any {
    return {
      forceDisplay: true,
    };
  }
}

export class SurvicateUser {
  constructor(email: string) {
    this.email = email;
  }

  public email: string;
}
